import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BuildConfigService } from '@common/util-foundation';
import {
  Basket,
  CreateQuoteRequest,
  CreateQuoteResponse,
  GetOfferRenewalQuoteRequest,
  ItemType,
} from '@common/util-models';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  addDiscountToBasket,
  addNumberSubsequentPaymentsToBasket,
} from '../utils/quotes-mapper/quotes-mapper.utils';

@Injectable()
export class QuotesApiService {
  constructor(
    private httpClient: HttpClient,
    private buildConfigService: BuildConfigService
  ) {}

  createQuote(
    createQuoteParams: CreateQuoteRequest | GetOfferRenewalQuoteRequest
  ) {
    const config = this.buildConfigService.config;
    const createQuoteUrl = `${config.basketApi}/quote`;
    return this.httpClient
      .post<{ result: CreateQuoteResponse }>(
        createQuoteUrl,
        createQuoteParams,
        {
          headers: this.headers,
        }
      )
      .pipe(
        map((response: { result: CreateQuoteResponse }) => response.result),
        map((quoteResponse: CreateQuoteResponse) => ({
          ...quoteResponse,
          basket: addNumberSubsequentPaymentsToBasket(quoteResponse.basket),
        })),
        map((quoteResponse: CreateQuoteResponse) => ({
          ...quoteResponse,
          basket: addDiscountToBasket(quoteResponse.basket),
        }))
      );
  }

  removeItemsFromQuote(
    basketId: string | undefined,
    ...itemIds: string[]
  ): Observable<Basket> {
    if (!basketId) {
      return throwError('No basket id provided');
    }
    return this.httpClient
      .post<{ result: Basket }>(
        `${this.buildConfigService.config.basketApi}/remove-items`,
        {
          basketId,
          itemIds,
          itemType: ItemType.Quote,
        },
        {
          headers: this.headers,
        }
      )
      .pipe(
        map((response: { result: Basket }) => response.result),
        map((basket: Basket) => addNumberSubsequentPaymentsToBasket(basket)),
        map((basket: Basket) => addDiscountToBasket(basket))
      );
  }

  private get headers(): { [key: string]: string } {
    return {
      'wl-client': this.buildConfigService.config.wlClient,
      'request-source': this.buildConfigService.config.catalogueStore,
      'request-action': this.buildConfigService.config.action,
    };
  }
}
